
const digest = '1002635c56462253f440b2dd28708cadb8fedb32dbe8057abe65a30d9b54d139';
const css = `._codeSnippet_1uny7_1 {
  font-family: monospace;
  color: #d14;
  border: 1px solid #e1e1e8;
  padding: 0 4px;
  margin: 0;
  border-radius: 3px;
  background-color: #f7f7f9;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"codeSnippet":"_codeSnippet_1uny7_1"};
export { css, digest };
  